export function getElementFromString( string ){
    const element = new DOMParser().parseFromString( string, 'text/html' );
    return element.body.childNodes[0];
}

export function clear( element ) {
    while ( element.firstChild ) {
        element.removeChild( element.lastChild);
    }
}

export function compareObjects(a,b) {
    return JSON.stringify(a) === JSON.stringify(b);
}

export function mergeObject(obj, defaultObj) {
	for (var prop in obj) {
		if (obj.hasOwnProperty(prop)) {
			// Push each value from `obj` into `extended`
			defaultObj[prop] = obj[prop];
		}
	}

	return defaultObj;
}

export function getSettings(){
    const _default = {
        format: 'YYYY-MM-DD',
        timeFormat: 'HH:mm:ss',
        prettyTime: 'hh:mm a',
        prettyDate: 'dddd, D MMMM YYYY'
    };

    if( ! window.hpyEvents || ! window.hpyEvents.formats ) {
        return _default;
    }

    return {
        format: hpyEvents.formats.date || _default.format,
        timeFormat: hpyEvents.formats.time || _default.timeFormat,
        prettyTime: hpyEvents.formats.prettyTime || _default.prettyTime,
        prettyDate: hpyEvents.formats.prettyDate || _default.prettyDate,
    };
}

export function getScrollbarWidth() {
    let outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.width = "100px";
    outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps

    document.body.appendChild(outer);

    let widthNoScroll = outer.offsetWidth;
    // force scrollbars
    outer.style.overflow = "scroll";

    // add innerdiv
    let inner = document.createElement("div");
    inner.style.width = "100%";
    outer.appendChild(inner);

    let widthWithScroll = inner.offsetWidth;

    // remove divs
    outer.parentNode.removeChild(outer);

    return widthNoScroll - widthWithScroll;
}

/**
 * Determine if passed variable is a function
 * @param {*} func 
 */
export function isFunction(func) {
	return func && {}.toString.call(func) === '[object Function]';
}

export function getEvent( type ){
    let event;
    
    if(typeof(Event) === 'function') {
        event = new Event(type);
    }else{
        event = document.createEvent('Event');
        event.initEvent(type, true, true);
    }

    return event;
}